import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "comment-list"
}

import { ref } from 'vue'
import { CommentApi } from './interface'
import ContentBox from './content-box.vue'
import ReplyBox from './reply-box.vue'

interface Props {
  data: CommentApi[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'comment-list',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: CommentApi[]
}



return (_ctx: any,_cache: any) => {
  return (__props.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (comment, index) => {
          return (_openBlock(), _createBlock(ContentBox, {
            key: index,
            "parent-id": comment.id,
            data: comment
          }, {
            userInfo: _withCtx(() => [
              _renderSlot(_ctx.$slots, "userInfo")
            ]),
            default: _withCtx(() => [
              _createVNode(ReplyBox, {
                "parent-id": comment.id,
                data: comment.reply
              }, {
                userInfo: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "userInfo")
                ]),
                _: 2
              }, 1032, ["parent-id", "data"])
            ]),
            _: 2
          }, 1032, ["parent-id", "data"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})